function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
var SvgDutch = function SvgDutch(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256"
  }, props), /*#__PURE__*/React.createElement(G, {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M2.57 30h84.859C81.254 12.534 64.611.015 45.033 0h-.068C25.388.015 8.745 12.534 2.57 30",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#ae1c28",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.407 1.407)scale(2.81)"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M87.429 60H2.57C8.749 77.476 25.408 90 45 90s36.25-12.524 42.429-30",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#21468b",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.407 1.407)scale(2.81)"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M87.429 60A44.9 44.9 0 0 0 90 45c0-5.261-.911-10.307-2.571-15H2.57A44.9 44.9 0 0 0 0 45c0 5.261.912 10.307 2.571 15z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#f3f4f5",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.407 1.407)scale(2.81)"
  })));
};
export default SvgDutch;